module.exports = __webpack_public_path__ + "img/teamwork-icon-8.835c5a48.png";